/**
 * 任务日志 assignmentLogModule
 * 2019-05-13
 * Qian.qianchen
 */
'use strict';
angular.module("assignmentLogModule", [])
    .controller("assignmentLogCtrl", ["$scope", "$modalInstance", "$q", "$timeout", "assignmentId", "trsHttpService", "$filter", function($scope, $modalInstance, $q, $timeout, assignmentId, trsHttpService, $filter) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                params: {
                    serviceid: "mlf_taskcommand",
                    methodname: "getTaskCommandLogs",
                    TaskId: assignmentId
                }
            };
            $scope.data = {
                operationLogTitle: '时间',
                operationLog: []
            };
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData().then(function() {
                logFormat(true);
            });
        }
        /**
         * [requestData description] 日志数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            let defer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, "POST").then(function(data) {
                $scope.data.operationArr = data;
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [logFormat description] 任务日志数据格式化
         * @return {[type]} [description]
         */
        function logFormat(order) {
            var today = new Date();
            angular.forEach($scope.data.operationArr, function(item, index) {
                let result = {
                        day: "",
                        times: []
                    },
                    crtime = "";;
                item.CRTIME = item.CRTIME.replace(/-/g, "/");
                crtime = new Date(item.CRTIME);
                var i = 0;
                var flag = true;
                for (; i < $scope.data.operationLog.length; i++) {
                    if ($filter("date")($scope.data.operationLog[i].day, "yyyy-MM-dd") === $filter("date")(crtime, "yyyy-MM-dd")) {
                        flag = false;
                        break;
                    }
                }

                var method = order ? 'push' : 'unshift';
                item.time = item.CRTIME.split(' ')[1];
                if (flag) {
                    result.day = $filter("date")(today, "yyyy-MM-dd") == $filter("date")(crtime, "yyyy-MM-dd") ? '今天' : $filter("date")(crtime, "yyyy-MM-dd");
                    result.times[method]({
                        value: item,
                        isShowOpinion: false
                    });
                    $scope.data.operationLog[method](result);
                } else if (angular.isDefined($scope.data.operationLog[i])) {
                    $scope.data.operationLog[i].times[method]({
                        value: item,
                        isShowOpinion: false
                    });
                }
            });
        }
        /**
         * [cancel description] 取消/关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [opinionToggle description] 意见展示与否
         * @param  {[type]} item [description] 时间轴对象
         * @return {[type]}      [description]
         */
        $scope.opinionToggle = function(item) {
            if (angular.isUndefined(item.isShowOpinion) || item.isShowOpinion == false) {
                item.isShowOpinion = true;
            } else {
                item.isShowOpinion = false;
            }
        }
    }]);